var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ensureFonts, loadImage } from './loadImage';
import { EXPORT_SCALE, INSTAGRAM_HEIGHT, INSTAGRAM_WIDTH } from './types';
var TEXT_MUTED = 'rgba(255, 255, 255, 0.8)';
var TEXT_WHITE = '#ffffff';
var HORIZONTAL_PADDING = 56;
var BOTTOM_PADDING = 72;
var TITLE_CONTENT_WIDTH = INSTAGRAM_WIDTH - HORIZONTAL_PADDING * 2;
var LOGO_WIDTH = INSTAGRAM_WIDTH * 0.14;
var LOGO_PADDING = 40;
var SIGNET_WATERMARK_WIDTH = INSTAGRAM_WIDTH * 0.8;
var SIGNET_WATERMARK_ALPHA = 0.32;
var GRADIENT_TOP = INSTAGRAM_HEIGHT * 0.45;
var GRADIENT_BOTTOM_ALPHA = 0.75;
function wrapText(ctx, text, maxWidth) {
    var words = text.split(/\s+/).filter(Boolean);
    var lines = [];
    var current = '';
    words.forEach(function (word) {
        var testLine = current ? "".concat(current, " ").concat(word) : word;
        if (ctx.measureText(testLine).width > maxWidth && current) {
            lines.push(current);
            current = word;
        }
        else {
            current = testLine;
        }
    });
    if (current) {
        lines.push(current);
    }
    return lines.length > 0 ? lines : [text];
}
function measureTextBlock(ctx, block) {
    ctx.font = block.font;
    return block.lines.length * block.lineHeight;
}
function drawTextBlock(ctx, block, x, startY, maxWidth) {
    ctx.fillStyle = block.color;
    ctx.font = block.font;
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    var y = startY;
    block.lines.forEach(function (line) {
        ctx.fillText(line, x, y, maxWidth);
        y += block.lineHeight;
    });
    return y;
}
function drawBackgroundPhoto(ctx, image) {
    var scale = Math.max(INSTAGRAM_WIDTH / image.width, INSTAGRAM_HEIGHT / image.height);
    var drawWidth = image.width * scale;
    var drawHeight = image.height * scale;
    var offsetX = (INSTAGRAM_WIDTH - drawWidth) / 2;
    var offsetY = (INSTAGRAM_HEIGHT - drawHeight) / 2;
    ctx.drawImage(image, offsetX, offsetY, drawWidth, drawHeight);
}
function drawSignetWatermark(ctx, signet) {
    var width = SIGNET_WATERMARK_WIDTH;
    var height = (signet.height / signet.width) * width;
    var x = INSTAGRAM_WIDTH - width;
    var y = (INSTAGRAM_HEIGHT - height) / 2;
    ctx.save();
    ctx.globalAlpha = SIGNET_WATERMARK_ALPHA;
    ctx.drawImage(signet, x, y, width, height);
    ctx.restore();
}
function drawGradientScrim(ctx) {
    var gradient = ctx.createLinearGradient(0, GRADIENT_TOP, 0, INSTAGRAM_HEIGHT);
    gradient.addColorStop(0, 'rgba(0, 0, 0, 0)');
    gradient.addColorStop(1, "rgba(0, 0, 0, ".concat(GRADIENT_BOTTOM_ALPHA, ")"));
    ctx.fillStyle = gradient;
    ctx.fillRect(0, GRADIENT_TOP, INSTAGRAM_WIDTH, INSTAGRAM_HEIGHT - GRADIENT_TOP);
}
function drawLogo(ctx, logo) {
    var width = Math.min(LOGO_WIDTH, logo.width);
    var height = (logo.height / logo.width) * width;
    var x = INSTAGRAM_WIDTH - width - LOGO_PADDING;
    var y = LOGO_PADDING;
    ctx.drawImage(logo, x, y, width, height);
}
export function renderCover(data) {
    return __awaiter(this, void 0, Promise, function () {
        var canvas, ctx, featured, signet, _a, logo, _b, blocks, blockGap, totalTextHeight, cursorY;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, ensureFonts()];
                case 1:
                    _c.sent();
                    canvas = document.createElement('canvas');
                    canvas.width = INSTAGRAM_WIDTH * EXPORT_SCALE;
                    canvas.height = INSTAGRAM_HEIGHT * EXPORT_SCALE;
                    ctx = canvas.getContext('2d');
                    if (!ctx) {
                        throw new Error('Canvas context unavailable');
                    }
                    ctx.scale(EXPORT_SCALE, EXPORT_SCALE);
                    ctx.imageSmoothingEnabled = true;
                    ctx.imageSmoothingQuality = 'high';
                    if (!data.featuredImageUrl) return [3 /*break*/, 3];
                    return [4 /*yield*/, loadImage(data.featuredImageUrl)];
                case 2:
                    featured = _c.sent();
                    drawBackgroundPhoto(ctx, featured);
                    return [3 /*break*/, 4];
                case 3:
                    ctx.fillStyle = '#cbd5e1';
                    ctx.fillRect(0, 0, INSTAGRAM_WIDTH, INSTAGRAM_HEIGHT);
                    _c.label = 4;
                case 4:
                    if (!data.signetUrl) return [3 /*break*/, 8];
                    _c.label = 5;
                case 5:
                    _c.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, loadImage(data.signetUrl)];
                case 6:
                    signet = _c.sent();
                    drawSignetWatermark(ctx, signet);
                    return [3 /*break*/, 8];
                case 7:
                    _a = _c.sent();
                    return [3 /*break*/, 8];
                case 8:
                    drawGradientScrim(ctx);
                    if (!data.logoUrl) return [3 /*break*/, 12];
                    _c.label = 9;
                case 9:
                    _c.trys.push([9, 11, , 12]);
                    return [4 /*yield*/, loadImage(data.logoUrl)];
                case 10:
                    logo = _c.sent();
                    drawLogo(ctx, logo);
                    return [3 /*break*/, 12];
                case 11:
                    _b = _c.sent();
                    return [3 /*break*/, 12];
                case 12:
                    blocks = [];
                    if (data.breadcrumbs) {
                        ctx.font = '400 24px Barlow, sans-serif';
                        blocks.push({
                            lines: wrapText(ctx, data.breadcrumbs, TITLE_CONTENT_WIDTH),
                            font: '400 24px Barlow, sans-serif',
                            color: TEXT_MUTED,
                            lineHeight: 32,
                            maxWidth: TITLE_CONTENT_WIDTH,
                        });
                    }
                    ctx.font = '700 68px Barlow, sans-serif';
                    blocks.push({
                        lines: wrapText(ctx, data.title, TITLE_CONTENT_WIDTH),
                        font: '700 68px Barlow, sans-serif',
                        color: TEXT_WHITE,
                        lineHeight: 78,
                        maxWidth: TITLE_CONTENT_WIDTH,
                    });
                    blocks.push({
                        lines: ["von ".concat(data.author)],
                        font: '400 30px Barlow, sans-serif',
                        color: TEXT_WHITE,
                        lineHeight: 40,
                        maxWidth: TITLE_CONTENT_WIDTH,
                    });
                    blocks.push({
                        lines: ["".concat(data.date, " | ").concat(data.readingTime, " min Lesezeit")],
                        font: '400 26px Barlow, sans-serif',
                        color: TEXT_MUTED,
                        lineHeight: 36,
                        maxWidth: TITLE_CONTENT_WIDTH,
                    });
                    blockGap = 20;
                    totalTextHeight = blocks.reduce(function (sum, block, index) {
                        return sum + measureTextBlock(ctx, block) + (index < blocks.length - 1 ? blockGap : 0);
                    }, 0);
                    cursorY = INSTAGRAM_HEIGHT - BOTTOM_PADDING - totalTextHeight;
                    blocks.forEach(function (block, index) {
                        drawTextBlock(ctx, block, HORIZONTAL_PADDING, cursorY, block.maxWidth);
                        cursorY += measureTextBlock(ctx, block);
                        if (index < blocks.length - 1) {
                            cursorY += blockGap;
                        }
                    });
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            canvas.toBlob(function (blob) {
                                if (blob) {
                                    resolve(blob);
                                }
                                else {
                                    reject(new Error('Failed to export cover'));
                                }
                            }, 'image/png');
                        })];
            }
        });
    });
}
